import apiClient from "@/lib/api/api-client";
import { env } from "@/config/env";

import { defaultThemeTokens } from "./defaultTheme";
import { normalizeThemeResponse } from "./createAppTheme";
import { getRequestedPlatform, resolvePlatform } from "./resolvePlatform";
import { getThemeMock } from "./themeMocks";
import type { Platform } from "./resolvePlatform";
import type { ThemeApiResponse, ThemeConfig } from "./types";

/**
 * Loads theme for the given platform.
 * Request shape (future backend): GET /api-portal/v1/theme?platform=glofox
 *
 * While VITE_THEME_USE_MOCK is true (default), returns mocked data
 * without calling the network. Falls back to neutral tokens on API error.
 */
export async function fetchTheme(platform?: Platform): Promise<ThemeConfig> {
  const resolvedPlatform = resolvePlatform(platform ?? getRequestedPlatform());

  if (env.themeUseMock) {
    return getThemeMock(resolvedPlatform);
  }

  try {
    const { data } = await apiClient.get<ThemeApiResponse>(env.themeApiPath, {
      params: { platform: resolvedPlatform },
    });
    return normalizeThemeResponse(data);
  } catch {
    return { platform: resolvedPlatform, tokens: defaultThemeTokens };
  }
}
